// add or update query param to url
export function updateUrlQuery(
  url: string,
  key: string,
  value: string
): string {
  const urlObject = new URL(url);
  urlObject.searchParams.set(key, value);
  return urlObject.toString();
}
